// 个人中心路由
export default [
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/my-account/account.vue').then((r) => r.default || r),
    meta: {
      requiresAuth: true,
      cnName: '个人中心页',
    },
    children: [
      {
        path: 'myAccount',
        name: 'myAccount',
        meta: {
          requiresAuth: true,
          cnName: '个人中心首页',
        },
        component: () =>
          import('@/views/my-account/my-account/my-account.vue').then((r) => r.default || r),
      },
      {
        path: 'accountSettings',
        name: 'accountSettings',
        meta: {
          requiresAuth: true,
          cnName: '账号设置页',
        },
        component: () =>
          import('@/views/my-account/my-settings/my-settings.vue').then((r) => r.default || r),
      },
      // 邮件修改密码的路由，与wap端保持一致
      {
        path: 'SettingInfoItem',
        name: 'SettingInfoItem',
        meta: {
          requiresAuth: true,
          cnName: '账号设置页',
        },
        component: () =>
          import('@/views/my-account/my-settings/my-settings.vue').then((r) => r.default || r),
      },
      {
        path: 'SettingUserInfo',
        name: 'SettingUserInfo',
        meta: {
          requiresAuth: true,
          cnName: '个人信息设置页',
        },
        component: () =>
          import('@/views/my-account/my-settings/my-settings.vue').then((r) => r.default || r),
      },
      {
        path: 'myPrescriptions',
        name: 'myPrescriptions',
        meta: {
          requiresAuth: true,
          cnName: '我的处方页',
        },
        component: () =>
          import('@/views/my-account/my-prescriptions/my-prescriptions').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'addPrescription',
        name: 'addPrescription',
        meta: {
          requiresAuth: true,
          cnName: '个人中心添加处方页',
        },
        component: () =>
          import('@/views/my-account/my-prescriptions/add-prescription').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'myAddressBook',
        name: 'myAddressBook',
        meta: {
          requiresAuth: true,
          cnName: '我的地址页',
        },
        component: () =>
          import('@/views/my-account/address/my-address-book').then((r) => r.default || r),
      },
      {
        path: 'myWishlist',
        name: 'myWishlist',
        meta: {
          requiresAuth: true,
          cnName: '我的心愿单页',
          feature_value_name: 'account_wishlist_recommend',
        },
        component: () =>
          import('@/views/my-account/my-wishlist/my-wishlist.vue').then((r) => r.default || r),
      },
      {
        path: 'recentlyViewed',
        name: 'recentlyViewed',
        meta: {
          requiresAuth: true,
          cnName: '浏览记录页',
        },
        component: () =>
          import('@/views/my-account/my-recently-viewed/my-recently-viewed').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'myReviews',
        name: 'myReviews',
        meta: {
          requiresAuth: true,
          cnName: '我的评论页',
        },
        component: () =>
          import('@/views/my-account/my-reviews/my-reviews.vue').then((r) => r.default || r),
      },
      {
        path: 'myCoupons',
        name: 'myCoupons',
        meta: {
          requiresAuth: true,
          cnName: '我的优惠券页',
        },
        component: () =>
          import('@/views/my-account/my-coupons/my-coupons.vue').then((r) => r.default || r),
      },
      {
        path: 'myWallet',
        name: 'myWallet',
        meta: {
          requiresAuth: true,
          cnName: '电子钱包页',
        },
        component: () =>
          import('@/views/my-account/my-wallet/my-wallet.vue').then((r) => r.default || r),
      },
      {
        path: 'myPoints',
        name: 'myPoints',
        meta: {
          requiresAuth: true,
          keepalive: true,
          cnName: '我的积分页',
        },
        component: () =>
          import('@/views/my-account/my-points/my-points').then((r) => r.default || r),
      },
      {
        path: 'refer-a-friend',
        name: 'referAfriend',
        meta: {
          requiresAuth: true,
          cnName: '邀请好友页',
        },
        component: () =>
          import('@/views/my-account/my-refer-a-friend/my-refer-a-friend.vue').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'my-orders/:status',
        name: 'myOrders',
        meta: {
          requiresAuth: true,
          cnName: '我的订单页',
        },
        component: () =>
          import('@/views/my-account/order-management/my-orders.vue').then((r) => r.default || r),
      },
      {
        path: 'order-detail/:id',
        name: 'orderDetail',
        meta: {
          requiresAuth: true,
          cnName: '订单详情页',
        },
        component: () =>
          import('@/views/my-account/order-management/order-detail.vue').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'myVoomer',
        name: 'myVoomer',
        meta: {
          requiresAuth: true,
          cnName: 'Voomer会员中心页',
        },
        component: () =>
          import('@/views/my-account/vip-center/my-vome.vue').then((r) => r.default || r),
      },
      {
        path: 'tickets',
        name: 'myTickets',
        meta: {
          requiresAuth: true,
          cnName: '我的工单页',
        },
        component: () =>
          import('@/views/my-account/my-tickets/my-tickets.vue').then((r) => r.default || r),
      },
      {
        path: 'Issues',
        name: 'afterSalesIssues',
        meta: {
          requiresAuth: true,
          cnName: '售后问题页',
        },
        component: () =>
          import('@/views/my-account/my-tickets/after-sales-issues.vue').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'Complaint-Sugguestion',
        name: 'complaintSugguestion',
        meta: {
          requiresAuth: true,
          cnName: '投诉和建议页',
        },
        component: () =>
          import('@/views/my-account/my-tickets/complaint-sugguestion.vue').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'buyVomerAddress/:style',
        name: 'buyVomerAddress',
        meta: {
          requiresAuth: true,
          cnName: 'Voomer会员开通页',
        },
        component: () =>
          import('@/views/my-account/vip-center/buy-vomer-address.vue').then((r) => r.default || r),
      },
      {
        path: 'buyVomerSuccess',
        name: 'vSuccess',
        meta: {
          requiresAuth: true,
          cnName: 'Voomer会员开通成功页',
        },
        component: () =>
          import('@/views/my-account/vip-center/buy-vomer-success.vue').then((r) => r.default || r),
      },
      {
        path: 'buyVomerFailed',
        name: 'vFailed',
        meta: {
          requiresAuth: true,
          cnName: 'Voomer会员开通失败页',
        },
        component: () =>
          import('@/views/my-account/vip-center/buy-vomer-failed.vue').then((r) => r.default || r),
      },
      {
        path: 'member-center',
        name: 'MemberCenter',
        meta: {
          requiresAuth: true,
          cnName: '会员中心页',
        },
        component: () =>
          import('@/views/my-account/member-center/member-center.vue').then((r) => r.default || r),
      },
      {
        path: 'questionnaires-list',
        name: 'QuestionnairesList',
        meta: {
          requiresAuth: true,
          cnName: '问卷调查',
        },
        component: () =>
          import('@/views/my-account/custom-question/index.vue').then((r) => r.default || r),
      },
      {
        path: 'my-card',
        name: 'MyCard',
        meta: {
          requiresAuth: true,
          cnName: '我的卡片',
        },
        component: () =>
          import('@/views/my-account/my-card/MyCard.vue').then((r) => r.default || r),
      },
    ],
  },
];
